"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } } function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }/* eslint-disable camelcase */




var _onboardingAnalytics = require('shared/constants/onboardingAnalytics');
var _react = require('@sentry/react'); var Sentry = _interopRequireWildcard(_react);
var _types = require('web/screens/Signup/types');
var _posthog = require('web/services/posthog'); var _posthog2 = _interopRequireDefault(_posthog);





var _signupAttribution = require('web/services/signupAttribution');

exports.ONBOARDING_EVENTS = _onboardingAnalytics.ONBOARDING_EVENTS;

/**
 * Dashboard step mapping for the web signup setup flow.
 *
 * Each `onboarding_step_viewed` and `onboarding_step_completed` event should include
 * the matching `step_key` and `step_index` so PostHog funnels can show where users
 * dropped out:
 * 1. personal_info: user enters name/email/phone basics.
 * 2. phone_mfa: user verifies the signup phone code, when required.
 * 3. password: user creates a password.
 * 4. org_info: user selects or creates organization relationships.
 * 5. Unassigned: retained for the retired org_survey_type step so historical
 *    PostHog funnels keep their existing alignment.
 * 6. org_survey_referrer: user answers how they heard about BloomText.
 * 7. product_interest: user picks what they want to use BloomText for (SMS / team chat / both).
 * 8. Unassigned: retained for the retired team_size step so historical
 *    PostHog funnels keep their existing alignment.
 * 14. legal_agreements: new-org creator accepts the BAA and Terms of Service.
 *     Indices are durable identities, not wizard sort keys.
 *
 * The post-auth continuation uses the literal
 * `PAYMENT_STEP_META` (step 9) since it renders in the authenticated app, not the
 * signup step machine. `finish`/13 marks landing in the inbox.
 */
 const ONBOARDING_STEP_META = {
  [_types.SetupSteps.PERSONAL_INFO]: { step_key: 'personal_info', step_index: 1 },
  [_types.SetupSteps.PHONE_MFA]: { step_key: 'phone_mfa', step_index: 2 },
  [_types.SetupSteps.PASSWORD]: { step_key: 'password', step_index: 3 },
  [_types.SetupSteps.ORG_INFO]: { step_key: 'org_info', step_index: 4 },
  [_types.SetupSteps.ORG_SURVEY_REFERRER]: { step_key: 'org_survey_referrer', step_index: 6 },
  [_types.SetupSteps.PRODUCT_INTEREST]: { step_key: 'product_interest', step_index: 7 },
  [_types.SetupSteps.LEGAL_AGREEMENTS]: { step_key: 'legal_agreements', step_index: 14 },
  [_types.SetupSteps.TRIAL_OFFER]: { step_key: 'payment', step_index: 9 },
  [_types.SetupSteps.FINISH]: { step_key: 'finish', step_index: 13 },
}; exports.ONBOARDING_STEP_META = ONBOARDING_STEP_META

/**
 * Literal step metadata for the in-app onboarding payment step. It sits between
 * the retired `team_size` index (8) and `phone_number` (10), but is not a
 * `SetupSteps` member because
 * the payment surface lives in the authenticated app, not the signup step machine.
 */
 const PAYMENT_STEP_META = { step_key: 'payment', step_index: 9 } ; exports.PAYMENT_STEP_META = PAYMENT_STEP_META

/** Literal step metadata for the non-paid book-a-demo continuation. */
 const DEMO_STEP_META = { step_key: 'book_demo', step_index: 11 } ; exports.DEMO_STEP_META = DEMO_STEP_META

/**
 * Literal step metadata for the post-checkout number-provisioning step (SMS
 * trials pick their BloomText number before landing in the inbox).
 */
 const PHONE_STEP_META = { step_key: 'phone_number', step_index: 10 } 









































































































; exports.PHONE_STEP_META = PHONE_STEP_META

const ATTRIBUTION_PROPERTY_KEYS = [
  'bt_landing_id',
  'bt_cta',
  'ph_distinct_id',
  'ph_session_id',
  'signup_distinct_id',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
] 

const DOWNLOAD_ATTRIBUTION_PARAM_KEYS = {
  bt_landing_id: 'bt_landing_id',
  bt_cta: 'bt_cta',
  ph_distinct_id: 'bt_ph_distinct_id',
  ph_session_id: 'bt_ph_session_id',
  signup_distinct_id: 'bt_signup_distinct_id',
  utm_source: 'utm_source',
  utm_medium: 'utm_medium',
  utm_campaign: 'utm_campaign',
  utm_term: 'utm_term',
  utm_content: 'utm_content',
  gclid: 'gclid',
}

const isSafeValue = (value) => (
  typeof value === 'string'
    || typeof value === 'number'
    || typeof value === 'boolean'
    || (Array.isArray(value) && value.every(v => typeof v === 'string'))
)

 const sanitizeOnboardingProperties = (
  properties,
) => {
  const output = {}
  Object.entries(properties).forEach(([key, value]) => {
    if (isSafeValue(value)) output[key] = value
  })
  return output
}; exports.sanitizeOnboardingProperties = sanitizeOnboardingProperties

const getSignupAttributionProperties = () => {
  const attribution = _signupAttribution.getSignupAttribution.call(void 0, )
  const properties = {}

  ATTRIBUTION_PROPERTY_KEYS.forEach(key => {
    const value = attribution[key]
    if (value) properties[key] = value
  })

  return properties
}

/**
 * Captures a frontend onboarding funnel event with the common dashboard dimensions:
 * `signup_source=webchat_signup`, `platform=web`, `onboarding_session_id`, and any
 * safe signup attribution properties found in the URL/storage.
 *
 * Use this only for funnel boundaries and step transitions. Minor UI interactions
 * should stay out of this helper to avoid bloating PostHog event volume.
 */
 const captureOnboardingEvent = (
  event,
  properties = {},
  options,
) => {
  _posthog2.default.capture(event, exports.sanitizeOnboardingProperties.call(void 0, {
    ...getSignupAttributionProperties(),
    signup_source: 'webchat_signup',
    platform: 'web',
    onboarding_session_id: _signupAttribution.getOrCreateOnboardingSessionId.call(void 0, ),
    ...properties,
  }), options)
}; exports.captureOnboardingEvent = captureOnboardingEvent

/**
 * Adds signup attribution to an app-download URL so a later mobile/desktop open can be
 * joined back to the same signup funnel via `bt_onboarding_session_id` and attribution IDs.
 */
 const buildAppDownloadUrlWithAttribution = (baseUrl) => {
  const attribution = _signupAttribution.getSignupAttribution.call(void 0, )
  const params = new URLSearchParams()

  ATTRIBUTION_PROPERTY_KEYS.forEach(key => {
    const value = attribution[key]
    if (value) params.set(DOWNLOAD_ATTRIBUTION_PARAM_KEYS[key], value)
  })

  params.set('bt_onboarding_session_id', _signupAttribution.getOrCreateOnboardingSessionId.call(void 0, ))

  const query = params.toString()
  const separator = baseUrl.includes('?') ? '&' : '?'
  return query ? `${baseUrl}${separator}${query}` : baseUrl
}; exports.buildAppDownloadUrlWithAttribution = buildAppDownloadUrlWithAttribution

 const getStepAnalyticsProperties = (step) =>
  exports.ONBOARDING_STEP_META[step]; exports.getStepAnalyticsProperties = getStepAnalyticsProperties

/**
 * The org keys where the user is a non-pending admin. This is the shared filter
 * used both to resolve the org just created by a new-org signup (from the login
 * response) and to sanity-check the `org` param on the payment screen. A pending
 * join request or a plain-member relationship is never a match.
 */
 const getNonPendingAdminOrgKeys = (
  relationships,
) =>
  (Object.entries(relationships || {}) )
    .filter(([, rel]) => rel.Type === 'admin' && !rel.Pending)
    .map(([orgKey]) => orgKey); exports.getNonPendingAdminOrgKeys = getNonPendingAdminOrgKeys

/**
 * Emits `onboarding_payment_abandoned` for a client-observed exit (Skip button
 * or a Stripe cancel return). The `expired` outcome is emitted server-side.
 */
 const captureOnboardingPaymentAbandoned = (properties



) => {
  exports.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.PAYMENT_ABANDONED, {
    ...exports.PAYMENT_STEP_META,
    ...properties,
  })
}; exports.captureOnboardingPaymentAbandoned = captureOnboardingPaymentAbandoned

/**
 * Emits `onboarding_checkout_started` when the user clicks the trial CTA on the
 * payment offer, before the Stripe redirect. The caller guards it once per
 * attempt; the offer-estimate properties record the configured plan at click
 * time (the Stripe round-trip loses the slider state, so this is the only
 * place they can be captured for a completed checkout — stitch via `attempt_id`).
 */
 const captureOnboardingCheckoutStarted = (properties


) => {
  // sendBeacon: the Stripe redirect follows immediately — a batched request
  // queued here is dropped on unload (observed live: the event never arrived).
  exports.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.CHECKOUT_STARTED, {
    ...exports.PAYMENT_STEP_META,
    ...properties,
  }, { transport: 'sendBeacon' })
}; exports.captureOnboardingCheckoutStarted = captureOnboardingCheckoutStarted

/**
 * Emits `onboarding_skip_dialog_viewed` when the skip-confirm dialog opens on
 * the payment offer (caller-guarded once per attempt). Views minus `skipped`
 * outcomes measure the dialog's rescue rate.
 */
 const captureOnboardingSkipDialogViewed = (properties


) => {
  exports.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.SKIP_DIALOG_VIEWED, {
    ...exports.PAYMENT_STEP_META,
    ...properties,
  })
}; exports.captureOnboardingSkipDialogViewed = captureOnboardingSkipDialogViewed








/**
 * Book-a-demo view/click events. Payment-step callout views are caller-guarded
 * once per attempt; clicks fire per interaction (navigation makes repeats rare).
 * Carries the demo source and optional offer context — never account details.
 */
 const captureOnboardingDemoCalloutViewed = (properties) =>
  exports.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.DEMO_CALLOUT_VIEWED, { ...exports.PAYMENT_STEP_META, ...properties }); exports.captureOnboardingDemoCalloutViewed = captureOnboardingDemoCalloutViewed

 const captureOnboardingDemoClicked = (properties) =>
  // sendBeacon: the scheduling-page navigation follows immediately — see
  // captureOnboardingCheckoutStarted.
  exports.captureOnboardingEvent.call(void 0, 
    _onboardingAnalytics.ONBOARDING_EVENTS.DEMO_CLICKED,
    { ...exports.PAYMENT_STEP_META, ...properties },
    { transport: 'sendBeacon' },
  ); exports.captureOnboardingDemoClicked = captureOnboardingDemoClicked

/** Emitted once per org when Calendly confirms an embedded booking. */
 const captureOnboardingDemoBooked = (properties


) =>
  exports.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.DEMO_BOOKED, {
    ...exports.DEMO_STEP_META,
    ...properties,
  }); exports.captureOnboardingDemoBooked = captureOnboardingDemoBooked

/**
 * Emits `onboarding_step_errored` when a funnel-blocking request fails with a
 * user-visible error surface, so PostHog can separate "abandoned" from "was
 * blocked by an error". When a caller safely reports the failure through
 * `log.error`, call this immediately afterward so `sentry_event_id` can point
 * at that report. Treat the
 * id as a lead, never a join key. This helper never throws and carries no raw
 * error message because messages can embed URLs or signer material.
 */
 const captureOnboardingStepErrored = (properties





) => {
  let sentryEventId
  try {
    sentryEventId = Sentry.lastEventId()
  } catch (e) {
    // Analytics must never throw into a failure path.
  }
  exports.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.STEP_ERRORED, {
    ...properties,
    sentry_event_id: sentryEventId,
  })
}; exports.captureOnboardingStepErrored = captureOnboardingStepErrored

/**
 * Returns org/user activation dimensions for app-open and conversion correlation.
 * Only stable IDs/counts/booleans are returned; org names, user names, email, phone,
 * message content, and raw survey text should not be added here.
 */
 const getPrimaryOrgContext = (user) => {
  const relationshipEntries = Object.entries(user.Relationships || {}) 
  const activeRelationships = relationshipEntries.filter(([, rel]) => !rel.Pending)
  const relationships = activeRelationships.length > 0 ? activeRelationships : relationshipEntries
  const organizationIds = relationships.map(([orgKey]) => orgKey )
  const isAdmin = relationships.some(([, rel]) => rel.Type === 'admin')

  return {
    user_id: user.UserKey,
    organization_id: organizationIds[0],
    organization_ids: organizationIds.length > 0 ? organizationIds : undefined,
    is_admin: isAdmin,
    user_created_at: user.CreatedAt,
    user_activated_at: user.ActivatedAt,
    user_activated: user.Activated,
  }
}; exports.getPrimaryOrgContext = getPrimaryOrgContext

/**
 * Emits `sms_trial_entry_clicked` when a declined-SMS-cohort user clicks a
 * "start your SMS trial" entry point (the finish surface button or the in-app
 * banner). Carries `{ organization_id, source }` only — the click source, never
 * any account/plan detail.
 */
 const captureSmsTrialEntryClicked = (properties


) => exports.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.SMS_TRIAL_ENTRY_CLICKED, properties); exports.captureSmsTrialEntryClicked = captureSmsTrialEntryClicked

/**
 * Captures `app_opened_after_signup` once when a logged-in user has signup attribution.
 * This is the bridge from web signup/onboarding to app adoption for the dashboard.
 */
 const captureWebAppOpenedAfterSignup = (user) => {
  const attribution = _signupAttribution.getSignupAttribution.call(void 0, )
  const hasSignupAttribution = !!(
    attribution.signup_distinct_id
      || attribution.ph_distinct_id
      || attribution.bt_landing_id
      || attribution.onboarding_session_id
  )

  if (!hasSignupAttribution || _signupAttribution.hasEmittedAppOpenedAfterSignup.call(void 0, )) return

  exports.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.APP_OPENED_AFTER_SIGNUP, exports.getPrimaryOrgContext.call(void 0, user))
  _signupAttribution.markAppOpenedAfterSignupEmitted.call(void 0, )
}; exports.captureWebAppOpenedAfterSignup = captureWebAppOpenedAfterSignup

/**
 * Captures the frontend paid-conversion signal when a user starts a paid-upgrade flow.
 * Backend Stripe webhook completion/lifecycle events are emitted by PR #210.
 */
 const captureSubscriptionConvertedToPaid = (
  properties,
) => {
  _posthog2.default.capture(
    _onboardingAnalytics.ONBOARDING_EVENTS.SUBSCRIPTION_CONVERTED_TO_PAID,
    exports.sanitizeOnboardingProperties.call(void 0, properties),
  )
}; exports.captureSubscriptionConvertedToPaid = captureSubscriptionConvertedToPaid

/**
 * Captures the frontend post-checkout success redirect signal with sanitized conversion
 * properties. Backend checkout completion is emitted separately by the Stripe webhook.
 */
 const captureSubscriptionStarted = (
  properties,
) => {
  _posthog2.default.capture(
    _onboardingAnalytics.ONBOARDING_EVENTS.SUBSCRIPTION_STARTED,
    exports.sanitizeOnboardingProperties.call(void 0, properties),
  )
}; exports.captureSubscriptionStarted = captureSubscriptionStarted
